import React, { useRef, useState, useEffect, useImperativeHandle } from "react";
import Quagga from "quagga";

const ScanBarCode = React.forwardRef(({ onScan, onStop, openCam }, ref) => {
  const scannerRef = useRef(null);
  const [isScanning, setIsScanning] = useState(false);
  const [stream, setStream] = useState(null);

  const startScanner = async () => {
      try {
        const mediaStream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" },
        });
        setStream(mediaStream);
  
        Quagga.init(
          {
            inputStream: {
              name: "Live",
              type: "LiveStream",
              target: scannerRef.current,
              constraints: {
                width: 640,
                height: 480,
                facingMode: "environment",
              },
            },
            decoder: {
              readers: ["ean_reader", "code_128_reader"],
            },
          },
          (err) => {
            if (err) {
              console.error("QuaggaJS initialization error:", err);
              return;
            }
            Quagga.start();
            setIsScanning(true);
          }
        );
  
        let hasDetected = false; // Flag to ensure single detection
  
        Quagga.onDetected((data) => {
          if (!hasDetected) {
            hasDetected = true; // Set flag to true after detection
            const detectedCode = data.codeResult.code;
            console.log(`Scanned barcode: ${detectedCode}`);
            onScan(detectedCode); // Notify parent component
            stopScanner(); // Stop scanner immediately
          }
        });
      } catch (error) {
        console.error("Error accessing camera:", error);
      }
  };
  

  const stopScanner = () => {
    if (isScanning) {
      Quagga.stop();
      Quagga.offDetected(); // Remove event listener
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
        setStream(null);
        onScan(null);
      }
      setIsScanning(false);
      if (onStop) onStop(); // Notify parent component about stopping
    }
  };

  useEffect(() => {
    if (openCam && !isScanning) {
      startScanner();
    } else if (!openCam) {
      stopScanner();
    }

    return () => {
      if (isScanning) {
        stopScanner();
      }
    };
  }, [openCam]);

  useImperativeHandle(ref, () => ({
    startScanner,
    stopScanner,
  }));

  return (
    <div
      ref={scannerRef}
      style={{paddingTop:'25px'}}
    />
  );
});

export default ScanBarCode;
